import React from 'react';

type BadgeVariant = 'paid' | 'unpaid' | 'shadow' | 'default';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
}

const Badge: React.FC<BadgeProps> = ({ children, variant = 'default' }) => {
  const variants: Record<BadgeVariant, React.CSSProperties> = {
    paid:    { background: 'var(--teal-dim)', color: 'var(--teal)', border: '1px solid var(--teal-mid)' },
    unpaid:  { background: 'var(--red-dim)', color: 'var(--red)', border: '1px solid var(--red-mid)' },
    shadow:  { background: 'var(--amber-dim)', color: 'var(--amber)', border: '1px solid oklch(0.80 0.14 75 / 0.3)' },
    default: { background: 'rgba(255,255,255,0.08)', color: 'var(--text1)', border: '1px solid var(--glass-border)' },
  };
  const v = variants[variant];
  return (
    <span style={{
      ...v,
      padding: '3px 9px',
      borderRadius: 100,
      fontSize: 11,
      fontWeight: 600,
      fontFamily: 'var(--mono)',
      letterSpacing: '0.02em',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
    }}>
      {children}
    </span>
  );
};

export default Badge;
